import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppConstants } from '@app/shared/app-constants';
import { getAppVersion, getLocalStorageString } from '@app/shared/app-utils';
import { InitializationService } from '@core/data-access/models/service.model';
import { selectRouteNestedParams } from '@core/data-access/store/router/router.selectors';
import { select, Store } from '@ngrx/store';
import { SetReloadRequired } from '@store/helpers/helper.actions';
import { has } from 'lodash';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigReload implements InitializationService {
  readonly #destroyRef = inject(DestroyRef);
  readonly #store = inject(Store);

  init() {
    this.initChangeEventRouteConfigReloadSubscription();
  }

  private initChangeEventRouteConfigReloadSubscription() {
    return this.#store
      .pipe(
        select(selectRouteNestedParams),
        filter((nesterRouterParams) => has(nesterRouterParams, 'id')),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(() => {
        const appVersion = getAppVersion();
        const oldAppVersion = getLocalStorageString(AppConstants.appVersionReducer);

        if (oldAppVersion === appVersion) {
          return;
        }

        this.#store.dispatch(new SetReloadRequired(true));
      });
  }
}
